import axios from "axios";

function fetchContent() {
  return axios.get("/api/pages.json").then((res) => res.data);
}

function fetchPage(slug) {
  return axios.get(`/api/pages/${slug}.json`).then((res) => res.data);
}

export default {
  fetchContent,
  fetchPage,
};
